// @flow
import React from 'react';
import styled from 'styled-components';

import { Button, Heading } from 'primitive-components';
import { colors } from 'bench-style-constants';
import { Grid } from 'layout-core-components';

const CenterText = styled.div`
  padding: 24px 70px;
  text-align: center;
  > p {
    color: ${colors.dust};
  }
`;

type TransactionSidebarSegmentingZeroStateProps = {
  onSetupSegmenting: Function,
};

export default function TransactionSidebarSegmentingZeroState({
  onSetupSegmenting,
}: TransactionSidebarSegmentingZeroStateProps) {
  return (
    <Grid column="1fr min-content 1fr">
      <span />
      <CenterText>
        <Heading size={2}>Get more insights from your reports</Heading>
        <p>
          Transaction Tagging lets you track areas of your business like projects, clients,
          locations, and more.
        </p>
        <Grid row="1fr max-content 1fr">
          <span />
          <Button styleType="primary" onClick={onSetupSegmenting}>
            Get Started
          </Button>
          <span />
        </Grid>
      </CenterText>
      <span />
    </Grid>
  );
}
